<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px"
        v-loading="loading">
        <el-row>

          <el-col :span="12">
            <el-form-item prop="productionDate" label="生产日期">
              <el-date-picker v-model="formData.productionDate" placeholder="请选择生产日期" type="date" clearable
                format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">

            <el-form-item prop="storageType" label="出入库类型">
              <el-select v-model="formData.storageType" clearable @change="changeStore" filterable
                placeholder="请选择出入库类型">
                <el-option v-for="(item, index) of typeArr" :value="item.value" :label="item.label"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="storageDate" label="出入库日期">
              <el-date-picker v-model="formData.storageDate" placeholder="请选择出入库日期" type="date" clearable
                format="yyyy-MM-dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item prop="specId" label="品种规格">
              <el-select v-model="formData.specId" clearable filterable placeholder="请选择品种规格">
                <el-option v-for="(item, index) of specArr" :value="item.specId" :label="item.specName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="品种规格" prop='specId'>
              <el-input clearable v-model="specName" @focus="dialogVisible = true" placeholder="品种规格" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="plateNumber" label="车牌号/罐号">
              <el-input v-model="formData.plateNumber" placeholder="请输入车牌号/罐号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="inventoryId" label="出入库工单">
              <el-input v-model="formData.inventoryId" placeholder="请输入出入库工单" clearable></el-input>

              <!-- <el-select v-model="formData.inventoryId" clearable filterable >
                <el-option v-for="(item, index) of storeArr" :value="item.inventoryId" :label="item.specName"
                  :key="index"></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="testResult" label="质检结果">
              <el-radio-group v-model="formData.testResult">
                <el-radio label="1">合格</el-radio>
                <el-radio label="2">不合格</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item prop="inspector" label="质检员">
              <el-select v-model="formData.inspector" clearable filterable placeholder="请选择质检员">
                <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item prop="goodsId" label="原料供应商">
              <!-- <el-input v-model="formData.goodsName" placeholder="请输入原料供应商" clearable></el-input> -->
              <el-select v-model="formData.goodsId" clearable filterable placeholder="请选择原料供应商">
                <el-option v-for="(item, index) of supplierArr" :value="item.materialsId" :label="item.materialsName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

    <SpecChoose :visible.sync="dialogVisible" @select="onSpecSelect"></SpecChoose>

  </div>
</template>

<script>
import SpecChoose from '@/components/SpecChoose.vue'

export default {
  name: 'QualityControlReportAdd',
  components: {
    SpecChoose
  },
  data() {
    return {
      specName: '',
      dialogVisible: false,
      formData: {
        productionDate: '',
        storageType: '',
        storageDate: '',
        specId: '',
        plateNumber: '',
        inventoryId: '',
        testResult: '',
        inspector: '',
        goodsId: '',
        fileList: []
      },
      //  1入库2出库
      typeArr: [
        {
          label: '入库',
          value: '1'
        },
        {
          label: '出库',
          value: '2'
        },
        {
          label: '外采外销',
          value: '3'
        }
      ],
      resArr: [
        {
          label: '合格',
          value: '1'
        },
        {
          label: '不合格',
          value: '2'
        }
      ],
      specArr: [],
      userList: [],
      storeArr: [],
      rules: {
        productionDate: [
          {
            required: true,
            message: '请选择生产日期',
            trigger: ['blur', 'change']
          }
        ],
        storageType: [
          {
            required: true,
            message: '请选择出入库类型',
            trigger: ['blur', 'change']
          }
        ],
        storageDate: [
          {
            required: true,
            message: '请选择出入库日期',
            trigger: ['blur', 'change']
          }
        ],
        specId: [
          {
            required: true,
            message: '请选择品种规格',
            trigger: ['blur', 'change']
          }
        ],
        plateNumber: [
          {
            required: false,
            message: '请输入车牌号/罐号',
            trigger: ['blur', 'change']
          }
        ],
        inventoryId: [
          {
            required: false,
            message: '请选择出入库工单',
            trigger: ['blur', 'change']
          }
        ],
        testResult: [
          {
            required: true,
            message: '请选择质检结果',
            trigger: ['blur', 'change']
          }
        ],
        // inspector: [
        //   {
        //     required: true,
        //     message: '请选择质检员',
        //     trigger: ['blur', 'change']
        //   }
        // ],
        goodsId: [
          {
            required: true,
            message: '请输入原料供应商',
            trigger: ['blur', 'change']
          }
        ]

      },
      loading: false,
      supplierArr: []

    }
  },
  created() {
    this.loadSupplier()
    this.loadUser()
    this.loadSpec()
    if (this.reportId) {
      this.loadData()
    }
  },
  computed: {
    reportId() {
      return this.$route.query.reportId
    },
    fileImgUrl() {
      const arr = this.formData.fileList.map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  methods: {
    onSpecSelect(data) {
      console.log('data', data)
      this.formData.specId = data.specId
      this.specName = data.specName
      this.dialogVisible = false
    },
    loadSupplier() {
      this.$axios.get(this.$apis.rawMaterialSupplier.selectPaRawMaterialsByList).then(res => {
        this.supplierArr = res.list || []
      })
    },
    changeStore(val) {
      this.storeArr = []
      this.formData.inventoryId = ''
      if (val) {
        // this.getStoreArr(val)
      }
    },
    getStoreArr(val) {
      this.$axios.get(this.$apis.cyCrkManage.selectYgnInoutRecordByPage, {
        params: {
          inoutType: val,
          inoutStatus: '2'
        }
      }).then(res => {
        this.storeArr = res.list
      })
    },
    loadSpec() {
      this.$axios
        .get(this.$apis.grainSpecifications.selectYxOilSpecByList)
        .then(res => {
          this.specArr = res.list
        })
    },
    loadUser() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '1'
      }).then(res => {
        this.userList = res.list || []
      })
    },
    loadData() {
      this.loading = true
      this.$axios
        .get(this.$apis.qualityControlReport.selectPaQcReportByReportId, {
          params: { reportId: this.reportId }
        })
        .then(res => {
          this.specName = res.specName
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    handleSuccess(res) {
      this.formData.fileList.push(res.data)
    },
    delImage(index) {
      this.formData.fileList.splice(index, 1)
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
      }
      return isImage && isLt10M
    },

    submit() {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.qualityControlReport.insertPaQcReport
          if (this.reportId) {
            url = this.$apis.qualityControlReport.updatePaQcReport
          }

          this.$axios.post(url, { ...this.formData }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-input,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}

.table-form {
  .table-form-item {
    padding: 10px 0;

    ::v-deep .el-form-item__content {
      .el-form-item__error {
        transform: translateY(-10px);
      }
    }

  }

}
</style>
